import { render, staticRenderFns } from "./saasFixUpgrade__form.vue?vue&type=template&id=a779a1c4"
import script from "./saasFixUpgrade__form.vue?vue&type=script&lang=js"
export * from "./saasFixUpgrade__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports